export default __webpack_public_path__ + "f76a33448a104a0016562ed93d72443a.png";